(function () {
  angular.module('MktzapApp.Factories')
    .factory('ListControlService', ListControlService);

    ListControlService.$inject = ['$resource'];

  function ListControlService ($resource) {
    return $resource('', {}, {
      getListControl: { url: frontUrl + '/list-control/getListControl', method: 'GET', isArray: false },
      registerListControl: { url: frontUrl + '/list-control/save', method: 'POST', params: {}, isArray: false },
      deleteListControl: { url: frontUrl + '/list-control/deleteListControl', method: 'POST', params: {}, isArray: false },
      uploadFile: { url: frontUrl + '/list-control/uploadFile', method: 'POST', params: {}, isArray: false }
    });

  }
})();
